import { CVStepPersonalInformationSchema } from 'schemas/cv-steps'
import { z } from 'zod'

const CVStepPersonalInformationValidator =
  CVStepPersonalInformationSchema.superRefine((val, ctx) => {
    if (
      val.phone &&
      !/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/.test(
        val.phone.replace(' ', '')
      )
    ) {
      ctx.addIssue({
        path: ['phone'],
        code: z.ZodIssueCode.custom,
        message: `custom.phone`
      })
    }
  })

export type ICVStepPersonalInformationValidator = z.infer<
  typeof CVStepPersonalInformationValidator
>

export default CVStepPersonalInformationValidator
